import React, { Component } from 'react'
import { connect } from 'react-redux'
import GameSelectors from '../../actions/game/game-selectors'
import LoadingIndicator from '../common/LoadingIndicator'
import GameRegister from '../../common/GameRegister.js'
import './game-history-cp.css'

// TODO: get the player move element from 
//import GameRegister from '../../common/GameRegister.js'

class GameHistoryCP extends Component {
  constructor() {
    super()
    this.playerDict = {}
  }

  render() {
    if (!this.props.gamePlayerList.length || !this.props.moveHistory || !this.props.initState) {
      return (
        <LoadingIndicator />
      )
    }

    if (
      !this.props.gameType
      || !this.props.stateChangeHistory
      || !(this.props.gameType in GameRegister.GameTypes)
    ) return (<></>)

    this.makePlayerDict()
    // TODO: revisit this component/function
    let historyFn = GameRegister.getGameElements(this.props.gameType).historyEle
    let phases = historyFn({
      playerDict: this.playerDict,
      moveHistory: this.props.moveHistory, 
      stateChangeHistory: this.props.stateChangeHistory, 
      initState: this.props.initState, 
    })

    // TODO: this is where the history control buttons will go 
    //  per each round / phase there will be buttons:
    //  - view 
    //  - branch off new game from here (probably just for dev subscribers) 
    // for (let i=0; i<phases.length; i++) {
    //   phases[i] = (
    //     <div key={i}>
    //       <div>menu!</div>
    //       {phases[i]}
    //     </div>
    //   )
    // }
    
    // TODO: set scroll to bottom
    //  overflow:auto; display:flex; flex-direction:column-reverse;
    //  to outer scrolling container eg move-history then add a container between move-history an rows
    return (
      <div className='move-history inverseScroll'>
        {phases}
        <div className='scrollAnchor'></div>
      </div>
    )
  }

  makePlayerDict () {
    // TODO: order players the same way as game
    this.playerDict = {}
    this.props.gamePlayerList.forEach(player => {
      this.playerDict[player.id] = player
    })
  }

  // these aren't working and I don't know why
  // componentDidMount () { 
  //   this.onStateChange()
  // }

  // componentDidUpdate (/*prevProps, prevState*/) {
  //   this.onStateChange()
  // }
}

const mapStateToProps = (state) => {
  return {
    moveHistory: state.game?.gameState?.move_history,
    gameType: state.game?.gameState?.game_type,
    gamePlayerList: GameSelectors.getGamePlayerList(state),
    stateChangeHistory: state.game?.gameState?.state_change_history,
    initState: state.game?.gameState?.init_state,
  }
}
  
const mapDispatchToProps = (dispatch) => {
  return {}
}
  
export default connect(mapStateToProps, mapDispatchToProps)(GameHistoryCP)
